export enum Database {
  CHRONOS_DEV = "Chronos",
  CHRONOS_PROD = "Chronos_prod",
}
